import { connect } from 'react-redux';
import AssetView from 'components/AssetView';
import * as Store from 'modules/index';
import { ComponentProps } from 'utility/ComponentProps';
import * as AsyncValue from 'utility/AsyncValue';

type StateProps = {
  _assetURLs: Record<string, string>,
};

type SynthesizedProps = Pick<ComponentProps<typeof AssetView>, 'fetchAssetURL'>;

type OwnProps = Omit<ComponentProps<typeof AssetView>, keyof (StateProps & SynthesizedProps)>;

const mapState = (state: Store.State): StateProps => ({
  _assetURLs: AsyncValue.flattenRecord(state.cache.assetURLs),
});

function mergeProps(
  { _assetURLs, ...stateProps }: StateProps,
  dispatchProps: {},
  ownProps: OwnProps
): ComponentProps<typeof AssetView> {
  return {
    fetchAssetURL: async (uuid: string): Promise<string> => {
      const url = _assetURLs[uuid];
      if (url == null) {
        return Promise.reject();
      }
      return url;
    },
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  };
}

const connector = connect(mapState, {}, mergeProps);

export default connector(AssetView);
